import React from "react";
import { Paper, Typography, Stack, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const CompactListCard = ({ guide }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        width: "100%",
        cursor: "pointer",
        '&:hover': {
          backgroundColor: "rgba(0,0,0,0.04)"
        }
      }}
      onClick={() => navigate(guide.path)}
    >
      <Typography variant="subtitle1" fontWeight={600} gutterBottom
        sx={{
          color: theme.palette.cardHeader.main,
        }}>
        {guide.title}
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {(guide.tags || []).map((tag) => (
          <Chip key={tag} label={tag} size="small"  onClick={() => {}}/>
        ))}
      </Stack>
    </Paper>
  );
};

export default CompactListCard;
